import script from "./CoursesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoursesView.vue?vue&type=script&setup=true&lang=ts"

import "./CoursesView.vue?vue&type=style&index=0&id=34618198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34618198"]])

export default __exports__